export async function resizeAndRotate(file, maxWidth = 1200, maxHeight = 1200) {
  try {
    // eslint-disable-next-line no-undef
    let i = await loadImage(file, {
      maxWidth,
      maxHeight,
      orientation: true,
      canvas: true,
    });
    let base64 = i.image.toDataURL('image/jpeg', 0.9);
    return dataURLtoFile(base64, file.name);
  } catch (error) {
    console.log(error);
    return file;
  }
}

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
